export const ADD_USER = "ADD_USER";

export const addUser = (payload) => {
  return { type: ADD_USER, payload };
};
